import * as userActions from 'redux/actions/user.actions'
import * as dashboardActions from 'redux/actions/dashboard.actions'

const initialState = {
  domainId: null,
  domains: null,
  websiteAudit: null,
  seoSavings: null,
  notifications: null,
  seoChecklist: null,
  keywordFinder: {
    history: null,
    list: null
  },
  reports: null,
  overview: null,
  movements: {
    visibilityChart: null,
    trafficChart: null,
    averageRankChart: null,
    serpFeaturesChart: null,
    positionChart: null
  }
}

const dashboardReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case dashboardActions.getDashboardDomainsSuccess.type: {
      return {
        ...state,
        domainId: payload.domainId,
        domains: payload.domains || []
      }
    }
    case dashboardActions.getDashboardDataSuccess.type: {
      return {
        ...state,
        [payload.payload.key]: payload.payload.value
      }
    }
    case userActions.logout.type:
      return initialState
    default:
      return state
  }
}
export default dashboardReducer
